import { GameSetupConfig } from '../configs/game-setup.config'
import { SitAtGameErrorCode } from '../error-codes/sit-at-game.error-code'
import { CommandResponse } from 'shared-services'
import { LeaveGameSetupErrorCode } from '../error-codes/leave-game-setup.error-code'
import { AcceptInviteErrorCode } from '../error-codes/accept-invite.error-code'
import { SitPosition } from 'game-play-services'

export class GameSetupPlayerService {
  public constructor(private readonly gameSetupConfig: GameSetupConfig) {}

  public async sitAtGame(
    gameShortId: string,
    sitPosition: SitPosition,
  ): Promise<CommandResponse<SitAtGameErrorCode>> {
    const body = {
      gameShortId,
      sitPosition,
    }

    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/sit-at-game`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    return (await response.json()) as CommandResponse<SitAtGameErrorCode>
  }

  public async leaveGame(
    gameShortId: string,
    sitPosition: SitPosition,
  ): Promise<CommandResponse<LeaveGameSetupErrorCode>> {
    const body = {
      gameShortId,
      sitPosition,
    }

    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/leave-game`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    return (await response.json()) as CommandResponse<LeaveGameSetupErrorCode>
  }

  public async acceptInvite(
    gameShortId: string,
    sitPosition: SitPosition,
  ): Promise<CommandResponse<AcceptInviteErrorCode>> {
    const body = {
      gameShortId,
      sitPosition,
    }

    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/accept-invite`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    return (await response.json()) as CommandResponse<AcceptInviteErrorCode>
  }
}
